import { Box } from '@chakra-ui/react';
import { Button } from 'src/components/atoms/Button';
import { Icon } from 'src/components/atoms/Icon';
import { useFilterContext } from 'src/contexts/FilterContext';

type CreateOptimizationButtonProps = {
  onClick: () => void;
};

export const CreateOptimizationButton: React.FC<
  CreateOptimizationButtonProps
> = ({ onClick }) => {
  const { currentModelVersion } = useFilterContext();

  return (
    <Box>
      <Button
        variant="primary"
        buttonName="create-optimization"
        disabled={!currentModelVersion}
        onClick={onClick}>
        <Icon iconName="plus" boxSize={4} mr={2} color="white" />
        Create Optimization
      </Button>
    </Box>
  );
};
